import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import ThemeToggle from "./ThemeToggle"; // Import the toggle component

function decodeToken(token: string) {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
}

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const navigation = [
    { name: "Dashboard", href: "/dashboard" },
    { name: "Account", href: "/account" },
  ];

  if (token) {
    const userData = decodeToken(token);
    if (userData && userData.role === "admin") {
      navigation.push({ name: "Admin", href: "/admin" });
    }
  }

  const handleSignOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userEmail");
    navigate("/");
  };

  return (
    <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:top-0 lg:bottom-0 lg:border-r lg:border-gray-200 dark:lg:border-gray-700 lg:bg-gray-100 dark:lg:bg-neutral-darker">
      <div className="flex flex-col flex-grow">
        <Link
          to="/"
          className="flex items-center gap-4 p-4"
        >
          <img src={logo} alt="Logo" className="h-10 w-auto" />
          <div className="flex flex-col justify-center">
            <span className="font-outfit font-bold text-xl leading-none text-indigo-900 dark:text-white">
              Swiftclear
            </span>
            <span className="font-arial font-light text-sm leading-none text-indigo-700 dark:text-gray-300">
              technologies
            </span>
          </div>
        </Link>

        <nav className="mt-5 flex-1 space-y-1 px-4">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`group flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 ${location.pathname === item.href
                  ? "bg-white text-indigo-900 dark:bg-neutral-light dark:text-gray-900"
                  : "text-indigo-700 dark:text-gray-300 hover:bg-white hover:text-indigo-900 dark:hover:bg-neutral-light dark:hover:text-gray-900"
                }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>


        <div className="pb-4 mt-auto space-y-1 px-4">
          <div className="mb-4 flex justify-start pl-4">
            <ThemeToggle />
          </div>
          <Link
            to="/contact-us"
            className="group flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 text-indigo-700 dark:text-gray-300 hover:bg-white hover:text-indigo-900 dark:hover:bg-neutral-light dark:hover:text-white"
          >
            Contact
          </Link>
          <button
            onClick={handleSignOut}
            className="group flex items-center px-4 py-2 text-sm font-medium rounded-md w-full text-left transition-colors duration-150 text-indigo-700 dark:text-gray-300 hover:bg-white hover:text-indigo-900 dark:hover:bg-neutral-light dark:hover:text-white"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
